import NotificationsPage from './NotificationsPage';

const NotificationsModule = {
  pages: [
    NotificationsPage,
  ],
};

export default NotificationsModule;
